import { useTranslation as useI18nTraslation } from 'react-i18next';
import useI18nInstance from './useI18nInstance';
import { addResources } from '../helpers/addResources';
import { Resources } from '../types';

const useTranslation = <Lang extends string>(namespace: string, resources: Resources<Lang>) => {
  const i18nInstance = useI18nInstance();
  addResources(i18nInstance, namespace, resources);

  return useI18nTraslation(namespace, { i18n: i18nInstance });
};

export default useTranslation;
